import React, { Fragment, useState } from "react";
import "./test.scss";
import Webcam from "react-webcam";
// import { Offline } from "react-detect-offline";
import Modal from "react-bootstrap/Modal";
import { useHistory, withRouter } from "react-router-dom/cjs/react-router-dom.min";


function TestView(props) {
  const [images, setImages] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [show, setShow] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [disable, setDisable] = useState(false)
  const [offline, setOffline] = useState(false)
  const history = useHistory();
  const webcamRef = React.useRef(null);

  const {
    activeFeedData,
    title,
    questions,
    quiz,
    quizCompleted,
    question,
    count,
    score,
    errorCount, eCount
  } = props;

  React.useEffect(() => {

    if (errorCount === 3 || eCount === 3) {
      setShow(true)
      setConfirm(true);
    }
    else if (errorCount > 3 || eCount > 3) {
      setConfirm(false);
      endTest();
    }
  }, [errorCount || eCount])

  React.useEffect(() => {
    if (navigator.onLine) {
      setOffline(false);
    } else {
      setOffline(true);
    }
  }, [offline])

  // const confirmExitTest = () => {
  //   setConfirm(true);
  // }

  const endTest = () => {
    setConfirm(false);
    setCancel(true);
    props.quizSubmited(activeFeedData.test_id, images, errorCount || eCount);
    // window.location.href = '/tests';
  }
  /* Close fullscreen */
  const closeFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) { /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { /* IE11 */
      document.msExitFullscreen();
    }
  }

  const exitTest = () => {
    if (props.learn) {
      closeFullscreen();
      window.location.reload();
      history.goBack();
    } else {
      window.location.href = '/tests'
    }
  }

  const capture = async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    const file = await dataURLtoFile(imageSrc, "png");
    await props.uploadImage(file);
    setImages([...images, props.image])
  };

  const dataURLtoFile = (dataurl, filename) => {
    var arr = dataurl.split(","),
      // mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: 'image/png' });
  };
  console.log(props.unlock)
  return (
    <div className="modal-body" style={{ background: "#fff" }}>

      <div className="test-holder text-center">
        {offline ?
          <div className="detector">
            You are offline
          </div>
          : null
        }
        {quiz ? (
          <div className="timer">
            <img src="/images/hour-glass.gif" alt="" height="50px" />
            <p>
              {props?.time?.m}:{props?.time?.s}
            </p>
          </div>
        ) : (
          <div onClick={() => props.closeQuizpopup()} className="close-quiz">
            {/* <img src="/images/close.svg" alt="" /> */}
          </div>
        )}

        {quiz ? (
          <Fragment>
            <h1 className="float-left mt-2" style={{ fontSize: 34, }}>
              {title}
            </h1>
            {question !== undefined && (
              <div
                className=""
                style={{ paddingTop: window.innerWidth > 767 ? '12%' : 100 }}
              >
                <p className="question-header">
                  Question {count + 1}/{questions.length}
                </p>

                <ul className="options">
                  <li className="ques-title ">
                    <small dangerouslySetInnerHTML={{ __html: question.title }} />
                  </li>
                  {question.answer_choices !== undefined &&
                    question.answer_choices.map((ans, index) => {
                      return (
                        <li
                          className=""
                          key={ans._id}
                        // style={{
                        //   pointerEvents:
                        //     question.answered !== null ? "none" : "auto",
                        // }}
                        >
                          <div
                            className={
                              question.answered === ans._id ?
                                "option1 ans-color"
                                : "option1"
                            }
                            onClick={() =>
                              props.selectAnswer(question._id, ans._id)
                            }
                            dangerouslySetInnerHTML={{ __html: ans.title }}
                          />
                        </li>
                      );
                    })}
                </ul>

                <div
                  className="fixed-prev "
                  style={{
                    marginLeft: window.innerWidth > 767 ? -25 : 5,
                    cursor: "pointer",
                  }}
                >
                  {count === 0 ? null : (
                    <div
                      className="prev-quiz"
                      onClick={() => {
                        props.getPrev(count);
                      }}
                    >
                      <img src="/images/left-arrow.png" width={12} alt="" />
                      &nbsp;Prev
                    </div>
                  )}
                  &nbsp;
                  {count + 1 === questions.length ? null : (
                    <div
                      className="next-quiz"
                      onClick={() => {
                        props.getNext(count);
                        !props.unlock && count % 3 === 0 && capture();
                      }
                      }
                    >
                      Next &nbsp;
                      <img src="/images/right-arrow.png" width={12} alt="" />
                    </div>
                  )}
                  {count + 1 === questions.length ? (
                    <div
                      className="next-quiz"
                      onClick={() => {
                        setDisable(true)
                        props.quizSubmited(activeFeedData.test_id, images, errorCount || eCount)
                      }}
                      style={{
                        display: "flex",
                        marginLeft: 40,
                        fontWeight: "600",
                        pointerEvents: disable ? 'none' : 'auto'
                      }}
                    >
                      Submit
                    </div>
                  ) : null}
                  {/* {count + 1 === questions.length ? null : <div className="prev-quiz" style={{ background: 'transparent', bottom: 30, left: '50%', transform: 'translate(-50%,0px)' }}>
                    <p onClick={confirmExitTest} style={{ color: '#8b7df2', marginTop: 0 }}>End test</p>
                  </div>} */}
                </div>

              </div>
            )}
          </Fragment>
        ) : quizCompleted ? (
          <div className="col-md-6 offset-md-3 d-flex justify-content-center flex-column align-items-center quiz-complete">
            {cancel ?
              <Fragment>
                <div className="mt-3">
                  <img
                    src="/images/sad.gif"
                    width="300px"
                    height="300px"
                    alt=""
                  />
                </div>
                <p>Try Again!</p>
                <p className="text-center">This test has been abandoned due to non-compliance of anti-cheat rules.</p>
              </Fragment> :
              score !== undefined && Number(score) > 60 ?
                <Fragment>
                  <div className="mt-3">
                    <img
                      src="/images/happy1.gif"
                      width="300px"
                      height="300px"
                      alt=""
                    />
                  </div>

                  <p>Congratulations!</p>
                  <p>You have aced the assessment.</p>
                  <p>You are now an official elite master of this skill.</p>
                  <small>You can download the certificate and view the detailed report from the 'Reports' in the Tests section.</small>
                </Fragment>
                : <Fragment>
                  <div className="mt-3">
                    <img
                      src="/images/sad.gif"
                      width="300px"
                      height="300px"
                      alt=""
                    />
                  </div>
                  <p>Try Again!</p>
                  <p className="text-center">You need to earn more than 60% to become an official elite master of this skill.</p>
                </Fragment>
            }
            <small>
              your score is
            </small>
            <div className="score">
              {score !== undefined && score}%
            </div>
            <button
              onClick={() => exitTest()}
              className="start-btn"
            >
              Return to Test
            </button>
          </div>
        ) : (
          <div className="col-md-6 offset-md-3 mt-3 d-flex justify-content-center flex-column align-items-center" style={{ paddingTop: '10%' }}>
            <h1>{title}</h1>
            <p>
              {activeFeedData.data !== undefined &&
                activeFeedData.data?.length}{" "}
              Multiple Choice Question | {Math.round(activeFeedData.time / 60)} Minutes
            </p>
            <div className="mt-3">
              <img
                src="/images/test-image.png"
                alt=""
                width={window.innerWidth > 767 ? 451 : 340}
              />
            </div>
            <small className="desc text-center">
              {activeFeedData.description}
            </small>
            <br />
            <button
              onClick={() => props.goToQuestion(questions[0])}
              className="start-btn"
            >
              Start Test
            </button>
          </div>
        )}
        {
          <div style={{ position: 'absolute', bottom: 0, right: 0, visibility: 'hidden' }}>
            {!props.unlock && <Webcam
              style={{ width: "100%", height: 250, display: props.unlock ? 'none' : 'block' }}
              audio={false}
              ref={webcamRef}
              // screenshotFormat="image/jpeg"
              mirrored={true}
              imageSmoothing={true}
              screenshotQuality={1}
            />}
          </div>
        }

        <Modal
          show={confirm}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          // onHide={this.handleCloseModal}
          dialogClassName={"confirm-modal"}
        >
          <div className="p-3 text-center">
            {
              show ?
                <Fragment>
                  <h1 style={{ color: '#e8325d', fontSize: 18 }}>Esc/Tab change not allowed. The test will end automatically incase of another violation</h1>
                  <div className="save-btn">
                    <button style={{ background: '#e8325d' }} onClick={() => {
                      setShow(false)
                      setConfirm(false)
                    }}>Ok</button>
                  </div>
                </Fragment>
                :
                <Fragment>
                  <h1>Are you sure you want to end the test without attempting all the questions?</h1>
                  <div className="text-center d-flex flex-column align-items-center p-1">
                    <p >This test will become invalid and you need to take it again.</p>
                  </div>
                  <div className="save-btn">
                    <button onClick={endTest}>Yes</button> &nbsp;&nbsp;
                    <button onClick={() => setConfirm(false)}>No</button>
                  </div>
                </Fragment>
            }

          </div>
        </Modal>
      </div>
    </div >
  );
}

export default withRouter(TestView)
